export default __webpack_public_path__ + "static/media/category_image_3.8f91a0fe.webp";